/**
 * bogo-offer.js — loaded globally via layout/theme.liquid.
 *
 * When ?bogo_offer=true is present in the URL:
 *   1. Shows all .element nodes (display: block).
 *   2. Appends ?bogo_offer=true to every /products/ link on the page so the
 *      parameter persists as the customer browses from collection to product.
 */
(function () {
  if (new URLSearchParams(window.location.search).get('bogo_offer') !== 'true') return;

  // Inject bogo-note after variant-selects on product pages (works for any layout)
  function injectBogoNote() {
    if (document.getElementById('bogo-note-tpl') && !document.querySelector('.bogo-note')) {
      var vs = document.querySelector('variant-selects');
      if (vs) {
        var node = document.getElementById('bogo-note-tpl').content.cloneNode(true).firstElementChild;
        vs.insertAdjacentElement('afterend', node);
      }
    }
  }

  function applyOffer(root) {
    var ctx = root || document;

    // 1. Show .element
    ctx.querySelectorAll('.element').forEach(function (el) {
      el.style.display = 'block';
    });

    // 2. Rewrite product links to carry ?bogo_offer=true
    ctx.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      try {
        var url = new URL(a.href, location.origin);
        if (url.searchParams.get('bogo_offer') !== 'true') {
          url.searchParams.set('bogo_offer', 'true');
          a.href = url.toString();
        }
      } catch (_) {}
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { injectBogoNote(); applyOffer(); });
  } else {
    injectBogoNote();
    applyOffer();
  }

  // Handle dynamically injected cards (infinite scroll, variant selector updates)
  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) applyOffer(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
